module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ccb22375c06ec83a1d74096b9722e150.png";